import React from "react";
import createStore from "./store";
import ConfigApp from "components/ConfigApp";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

const store = createStore();
let persistor = persistStore(store);

export const isSafari = /^((?!chrome|android).)*safari/i.test(
	navigator.userAgent
);

const App = () => {
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<ConfigApp />
			</PersistGate>
		</Provider>
	);
};

export default App;
